import type { AppAbility } from '@/modules/identity/application/ability';

// Roles fijos de autoservicio (residente): sus habilidades harcodeadas en @yawi/casl
// (leer sus propios Charge/Payment/Ticket/Poll/User/AccessControl/Supplier, etc.) hacen
// que muchos de los checks de abajo den `true` con un ability.can(action, subject) simple
// (CASL ignora las condiciones de ownership cuando se consulta solo por tipo de sujeto,
// sin instancia). Sin este bloqueo, cualquier residente/familiar/guardia calificaba para
// ver el layout de administración — no por tener permisos de admin, sino por tener acceso
// de lectura a sus propias cosas. `STAFF` mapea al mismo perfil de habilidades que
// RESIDENT (ver toAbilityUser en ability.ts), así que se excluye igual.
const SELF_SERVICE_TENANT_ROLES = new Set(['RESIDENT', 'FAMILIAR', 'GUARD', 'STAFF']);

export const canUseAdminLayoutV2 = (ability: AppAbility, tenantRole?: string | null): boolean => {
  if (SELF_SERVICE_TENANT_ROLES.has(String(tenantRole || '').toUpperCase())) {
    return false;
  }

  return (
    ability.can('manage', 'all')
    || ability.can('read', 'Unit')
    || ability.can('read', 'ResidentMenu')
    || ability.can('read', 'StaffMenu')
    || ability.can('read', 'RoleMenu')
    || ability.can('read', 'User')
    || ability.can('read', 'Role')
    || ability.can('read', 'AccessControl')
    || ability.can('read', 'AccessLog')
    || ability.can('read', 'AccessDevice')
    || ability.can('read', 'RfidCredential')
    || ability.can('read', 'Ticket')
    || ability.can('read', 'Poll')
    || ability.can('read', 'Charge')
    || ability.can('read', 'Payment')
    || ability.can('read', 'Expense')
    || ability.can('read', 'Supplier')
    || ability.can('read', 'SupplierVisit')
    || ability.can('read', 'Settings')
    || ability.can('read', 'NotificationConfig')
    || ability.can('read', 'Routine')
    || ability.can('read', 'RoutineExecution')
  );
};
